import {ShareModal} from "./build-modal.js"
import {copyToClipboard} from "../../utils/clipboard.js"
import { el } from "redom"

export const createUserShareModal = (uploaderId: string) => new ShareModal(createShareContent("u/" + uploaderId))

export const createRecordShareModal = (recordId: string, embed: boolean) => {
    const path = "r/" + recordId
    return embed ? new ShareModal(createShareContent(path)) : createShareModalIncludingEmbed(path)
}

const createShareBody = (text: string) =>
    el("div.row", { style: "padding: 10px 0;", onclick: () => copyToClipboard(text)},
        el("div.col me-auto", { style: "padding: 0px 0px 0px 20px" },
            el("input.form-control", { type: "text", placeholder: text, readonly: "true" })),
        el("div.col-auto align-middle", { style: "padding: 0px 20px 0px 5px"},
            el("button.btn btn-secondary btn-sm", { type: "button", style: "height: 37px" },
                el("i.far fa-clipboard", { style: "font-size: 25px;" } ))
        )
    )

const createShareContent = (path: string) => {
    const mainBody = document.createDocumentFragment()
    const url = window.location.origin + "/" + path

    mainBody.appendChild( createShareBody(url) )

    // facebook share
    mainBody.appendChild(
        el("a.fb-xfbml-parse-ignore", { target: "_blank", href: "https://www.facebook.com/sharer/sharer.php?u=" + url + "/&src=sdkpreparse"},
            el("#fb-share-button", { "data-href": url }, el("h6.shareModalItem", "Facebook") )
        )
    )
    // twitter share
    mainBody.appendChild(
        el("a.twitter-share-button", { target: "_blank", href: "https://twitter.com/intent/tweet?text=Shared%20page%20:%20&url=" + url + "&hashtags=soundcorset", "data-text": "Share page : ", "data-via": "soundcorset", "data-count": "horizontal" },
            el("div", el("h6.shareModalItem", "twitter"))
        )
    )
    // google+ share
    const googleHref = "https://plus.google.com/share?url=" + url
    mainBody.appendChild(
        el("a.", { target: "_blank", href: googleHref , onclick: () => { window.open(googleHref, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600"); return false; } },
            el("div", el("h6.shareModalItem", "Google+"))
        )
    )
    // email share
    mainBody.appendChild(
        el("a", { href: "mailto:?subject=Shared page&body=" + url + " %0Ashared via Soundcorset."},
            el("div", el("h6.shareModalItem", "e-mail"))
        )
    )

    return el("center", mainBody)
}

const createShareModalIncludingEmbed = (path: string) => {
    const embedHtml = "<iframe width='100%' height='115' scrolling='no' frameborder='no' autostart='0' src='/soundcorset.frontend/assets/static?embed=true'><" + window.location.origin + "/" + path + "iframe>"
    const _SHARE = "share"
    const _EMBED = "embed"
    const displayShareOrEmbed = (evt: Event) => {
        const isShare = (evt.currentTarget as HTMLElement)?.id.includes(_SHARE)
        const active = isShare ? _SHARE : _EMBED
        const inactive = isShare ? _EMBED : _SHARE
        document.getElementById(inactive + "Tab")?.classList.remove("active")
        document.getElementById(active + "Tab")?.classList.add("active")
        const inactiveContent = document.getElementById(inactive + "Content")
        if(inactiveContent) inactiveContent.style.display = "none"
        const activeContent = document.getElementById(active + "Content")
        if(activeContent) activeContent.style.display = "block"
    }
    const createTab = (shareOrEmbed: string, active: boolean) =>
        el("span#" + shareOrEmbed + "Tab.shareOrEmbedLinks" + (active? " active" : "" ), { onclick: displayShareOrEmbed },
            el("h6.subHead", shareOrEmbed.toUpperCase()))

    const embedBody =
        el("center",
            el("div.shareOrEmbedTabs", createTab(_SHARE, true), createTab(_EMBED, false) ),
            el("div.shareOrEmbedTabContent#" + _SHARE + "Content", { style: "display: block;" }, createShareContent(path) ),
            el("div.shareOrEmbedTabContent#" + _EMBED + "Content", { style: "display: none;" }, createShareBody(embedHtml) )
        )
    const shareModal = new ShareModal(embedBody)
    shareModal.removeTitle()
    shareModal.noPaddingInBody()
    return shareModal
}
